import React from 'react';

import { CSSInterpolation } from '@emotion/css/create-instance';
import { css } from '@emotion/react';
import { CssVars } from '@robinhood/design';

interface PropsIface {
  style?: CSSInterpolation;
}

const Divider = ({ style }: PropsIface) => {
  return <div css={[root, style]} />;
};

const root = css`
  border-bottom: 1px solid ${CssVars.neutral.bg3};
  width: 100%;
`;

export default Divider;
